import { ComponentMultiStyleConfig } from "@chakra-ui/react";
import { focusRing } from "../focusStyles";

// The default theme does not adjust padding based on viewport,
// but we do want to have less padding on small devices
const modalPadding = {
  px: {
    base: 2,
    xs: 4,
    sm: 6,
  },
};

export const modalTheme: ComponentMultiStyleConfig = {
  parts: ["dialog", "header", "body", "footer"],
  baseStyle: {
    header: {
      ...modalPadding,
      fontWeight: "bold",
      pr: 12, // ensure we don't overlap the close button
    },
    body: {
      ...modalPadding,
      _focusVisible: {
        ...focusRing,
      },
    },
    footer: {
      ...modalPadding,
    },
  },
  sizes: {
    full: {
      dialog: {
        borderRadius: "none",
        borderWidth: 0,

        // This is specifically to ensure that modals
        // do not exceed the display height on mobile devices.
        maxH: "100dvh",
        maxW: "100dvw",
      },
    },
  },
};
